import { Container, Skeleton } from '@ag1/ui';
import { navigationClickEvent } from 'analytics/events/studio';
import clsx from 'clsx';
import Link from 'next/link';
import { useRef } from 'react';
import { generateTextBoxWidth } from 'shared/utils/generateTextBoxWidth';
import { useMedia } from 'state/context/MediaContext';
import { useScrollIntoView } from '../../hooks/useScrollIntoView';
import { arrToSingleValue } from '../../utils/arrToSingleValue';
import { useIsNavItemActive } from './hooks/useIsNavItemActive';
import { useStickyHeader } from './hooks/useStickyHeader';
import styles from './Nav.module.scss';
import { NavPropsType } from './Nav.types';

const Nav = ({ links, ariaLabel = 'membership portal', isLoading }: NavPropsType) => {
  const headerRef = useRef(null);

  const checkIsNavItemActive = useIsNavItemActive();
  const scrollIntoViewFunction = useScrollIntoView();
  const { atSmall } = useMedia();
  const { sticky: headerSticky, visible: headerVisible } = useStickyHeader(headerRef, atSmall);

  return (
    <nav
      aria-label={ariaLabel}
      className={clsx(styles.nav, headerSticky && headerVisible && styles.headerVisible)}>
      <Container>
        <ul className={styles.list}>
          {links.map(({ id, title, path }) => {
            const isActive = checkIsNavItemActive(path);

            return (
              <li className={styles.item} key={id}>
                {isLoading ? (
                  <div className={clsx(styles.link, styles.loading)}>
                    <Skeleton width={`${generateTextBoxWidth(title)}px`} height={24} />
                  </div>
                ) : (
                  <Link
                    ref={isActive ? scrollIntoViewFunction : undefined}
                    href={arrToSingleValue(path)}
                    aria-current={isActive ? 'page' : undefined}
                    className={clsx(styles.link, { [styles.active]: isActive })}
                    onClick={() =>
                      navigationClickEvent({
                        navigationType: 'link',
                        clickText: title,
                        location: 'portal'
                      })
                    }>
                    {title}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </Container>
    </nav>
  );
};

export default Nav;
